export class ColorHelper {
  private assetColors: Record<string, string>;

  static COLORS = [
    '#1ddd58',
    '#F79E1B',
    '#67B6C7',
    '#F33F3F',
    '#8FD947',
    '#FF5F00',
    '#006B6B',
    '#B500B5',
    '#7BA81C',
    '#FF0000',
    '#FF8787',
    '#2E96FF',
    '#9A7D0A',
    '#F48FB1',
    '#00A8CC',
    '#C70039',
    '#FF9F1C',
    '#6A0572',
    '#1DB954',
    '#FFB700',
    '#009688',
    '#6F4E37',
    '#F06292',
    '#7F00FF',
    '#FFC300',
    '#004D40',
    '#7B1FA2',
    '#00BFA5',
    '#D81B60',
    '#FF6F61',
    '#7E57C2',
    '#6200EA',
    '#2D3A45',
    '#CDDC39',
    '#00ACC1',
    '#5C6BC0',
    '#FFEB3B',
    '#3F51B5',
    '#AFB42B',
    '#FF7043',
    '#3E2723',
    '#FF80AB',
    '#00C853',
    '#FF4081',
    '#BA68C8',
    '#FF8A65',
    '#0091EA',
    '#689F38',
    '#EC407A',
    '#3D5AFE',
    '#26C6DA',
    '#E91E63',
    '#AB47BC',
    '#FFAB00',
    '#006064',
    '#DCE775',
    '#FBC02D',
    '#4CAF50',
    '#FF5252',
    '#81C784',
    '#00E676',
    '#76FF03',
    '#FFCA28',
    '#795548',
    '#FF3D00',
    '#33691E',
    '#FF5722',
    '#304FFE',
    '#AEEA00',
    '#1A237E',
    '#69F0AE',
    '#448AFF',
    '#BF360C',
    '#FFC107',
    '#00C8FF',
    '#B0BEC5',
    '#2962FF',
    '#7C4DFF',
    '#1DE9B6',
    '#F57C00',
    '#9575CD',
    '#D50000',
    '#607D8B',
    '#C51162',
    '#512DA8',
    '#FFB74D',
    '#64FFDA',
    '#FF9100',
    '#0097A7',
    '#FFB300',
    '#039BE5',
    '#388E3C',
    '#D32F2F',
    '#FF6D00',
    '#546E7A',
    '#00BCD4',
    '#4DB6AC',
    '#303F9F',
    '#0277BD',
  ];

  static INDEX_COLORS = {
    '#0000E0': 'cdi:idx',
    '#D47500': 'ibov:idx',
    '#DB0A5B': 'ipca:idx',
    '#600060': 'poup:idx',
    '#00AA00': 'selic:idx',
    '#527AC2': 'dolar:idx',
    '#939393': 'ibxx:idx',
    '#6B8E23': 'ima-b:idx',
    '#FF00FF': 'ihfa:idx',
    '#8D6708': 'igp-m:idx',
    '#E26A6A': 'irf-m:idx',
    '#1D781D': 'idiv:idx',
    '#545454': 'smll:idx',
    '#8778E8': 'sp500:idx',
  };

  constructor() {
    this.assetColors = ColorHelper.COLORS.reduce(
      (total, current) => ({ ...total, [current]: null }),
      {}
    );

    this.assetColors = { ...this.assetColors, ...ColorHelper.INDEX_COLORS };
  }

  setColor(id: string): string {
    const current = Object.values(this.assetColors).find((item) => item === id);

    if (current) {
      return this.getColor(id);
    }

    try {
      const [emptyColor] = Object.entries(this.assetColors).find(
        ([, item]) => !item
      )!;

      this.assetColors[emptyColor] = id;
      return emptyColor;
    } catch (error) {
      return '#333';
    }
  }

  getColor(id: string): string {
    try {
      const [color] = Object.entries(this.assetColors).find(
        ([, item]) => item === id
      )!;

      return color;
    } catch (error) {
      return '#333';
    }
  }

  removeColor(id: string): void {
    try {
      const [cleanColor]: any = Object.entries(this.assetColors).find(
        ([, fund]) => fund === id
      );

      this.assetColors = { ...this.assetColors, [cleanColor]: null };
    } catch (error) {
      return;
    }
  }

  assetHasColor(id: string): boolean {
    try {
      const [color] = Object.entries(this.assetColors).find(
        ([, fund]) => fund === id
      )!;

      return true;
    } catch (error) {
      return false;
    }
  }

  resetColors(): void {
    this.assetColors = ColorHelper.COLORS.reduce(
      (total, current) => ({ ...total, [current]: null }),
      {}
    );
  }
}
